<template>
    <div id="systemmodule">
        <HrrBreadcrumb PMname="设备指令与日志" CMname="上传解码管理" />
        <HrrMainLayout>
            <template slot="searh">
                <el-form :inline="true" :model="searchform">
                    <el-form-item>
                        <el-input v-model="keyword" placeholder="关键字">
                            <el-select v-model="selectfield" slot="prepend" placeholder="请选择" class="input-with-select">
                                <el-option label="设备编号" value="deviceCode"></el-option>
                                <el-option label="接收内容" value="advertisementCode"></el-option>
                            </el-select>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="接收时间：">
                        <el-date-picker v-model="searchform.startPostTime" placeholder="开始时间" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="至">
                        <el-date-picker v-model="searchform.endPostTime" placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="状态：" prop="devStatus" v-if="false">
                        <el-select v-model="searchform.devStatus" placeholder="请选择">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="发送" :value="1"></el-option>
                            <el-option label="未发送" :value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">查询</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-checkbox v-model="IsRefresh" @change="Refreshchange()">自动刷新</el-checkbox>
                    </el-form-item>
                    <el-form-item v-if="IsRefresh">
                        <el-select v-model="RefreshNum" placeholder="请选择" @change="Refreshchange()">
                            <el-option v-for="item in RefreshData" :key="item.value" :label="item.name" :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </template>
            <template slot="buttons">
                <el-button-group>
                    <el-button type="primary" icon="el-icon-edit" size="small" @click="Addclick" v-if="false">新增</el-button>
                    <el-button type="primary" icon="el-icon-edit-outline" size="small" @click="editclick" v-if="false">编辑</el-button>
                    <el-button type="primary" icon="el-icon-delete" size="small" @click="delclick" v-if="false">删除</el-button>
                    <el-button type="primary" icon="fa fa-check-square-o" size="small" v-if="false">审核</el-button>
                </el-button-group>
            </template>
            <template slot="table">
                <el-table :data="tableData" ref="Opentable" @cell-click="cellclick" @selection-change="selectionchange" border stripe style="width: 100%" v-loading="loading">
                    <el-table-column type="selection" width="55" fixed="left">
                    </el-table-column>
                    <el-table-column prop="postTime" label="接收时间" width="160" fixed="left" sortable>
                    </el-table-column>
                    <el-table-column prop="deviceNickCode" label="设备编号" width="120" fixed="left" sortable>
                    </el-table-column>
                    <el-table-column prop="deviceCode" label="自动设备编号" width="120" fixed="left" v-if="isHadFun('deviceCode')">
                    </el-table-column>
                    <el-table-column prop="deviceName" label="设备名称" width="140" fixed="left" sortable>
                    </el-table-column>
                    <el-table-column prop="advertisementCode" label="接收内容" width="180">
                    </el-table-column>
                    <el-table-column prop="I1" label="电流A(安)" width="100">
                    </el-table-column>
                    <el-table-column prop="I2" label="电流B(安)" width="100">
                    </el-table-column>
                    <el-table-column prop="I3" label="电流C(安)" width="100">
                    </el-table-column>
                    <el-table-column prop="light" label="亮度(%)" width="100">
                    </el-table-column>
                    <el-table-column prop="workTime" label="工作时长(小时)" width="140">
                    </el-table-column>
                    <el-table-column prop="PM10" label="PM10" width="100">
                    </el-table-column>
                    <el-table-column prop="PM25" label="PM25" width="100">
                    </el-table-column>
                    <el-table-column prop="smoke" label="烟雾" width="100">
                    </el-table-column>
                    <el-table-column prop="temperature" label="温度" width="100">
                    </el-table-column>
                    <el-table-column prop="humidity" label="湿度" width="100">
                    </el-table-column>
                    <el-table-column label="状态" width="70" fixed="right" v-if="false">
                        <template slot-scope="scope">
                            <el-tag effect="dark" type="success" disable-transitions v-if="scope.row.devStatus==1">发送</el-tag>
                            <el-tag effect="dark" type="warning" disable-transitions v-if="scope.row.devStatus==2">未发送</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="creationDate" label="创建时间" width="200" sortable>
                    </el-table-column>
                    <el-table-column prop="updateDate" label="修改时间" width="200" v-if="false">
                    </el-table-column>
                    <el-table-column prop="flag" label="标志位" width="100">
                    </el-table-column>
                    <el-table-column label="操作" width="150" fixed="right" v-if="false">
                        <template slot-scope="scope">
                            <el-button @click.stop="Rowview(scope.row)" type="text" size="small" v-if="false">查看</el-button>
                            <el-button @click.stop="RowEdit(scope.row)" type="text" size="small" v-if="false">编辑</el-button>
                            <el-button @click.stop="Rowdelete(scope.row)" type="text" size="small" v-if="false">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
            <template slot="Pagination">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchform.pageNum" :page-sizes="[5, 10, 15]" layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </template>
        </HrrMainLayout>
    </div>
</template>
<script>
export default {
    name: 'device_reldata',
    data() {
        return {
            searchform: {
                pageNum: 1,
                pageSize: 10,
                deviceCode: "",
                advertisementCode: "",
                startPostTime: null,
                endPostTime: null,
                devStatus: "",
            },
            myform: {
                cmd: ""
            },
            lightform: {
                time: "",
                percentage: 1
            },
            startform: {
                min: "",
                number: "02"
            },
            cmdform: {
                MN: "",
                Content: ""
            },
            tableData: [],
            planIdData: [],
            timeData: [],
            numberData: ["01", "02", "04", "06", "08", "12", "24"],
            RefreshData: [{ value: 1, name: "1秒" }, { value: 5, name: "5秒" }, { value: 10, name: "10秒" }],
            total: 0,
            IsRefresh: false,
            RefreshNum: 5,
            loading: true,
            selectionRows: [],
            selectfield: "deviceCode",
            keyword: "",
            dialogVisible: false,
            timeId: 0
        }
    },
    methods: {
        onSubmit() {
            this.searchform.deviceCode = "";
            this.searchform.advertisementCode = "";
            this.searchform.pageNum = 1;
            this.searchform[this.selectfield] = this.keyword.trim();
            if (this.searchform.startPostTime != null && this.searchform.endPostTime != null) {
                var nowDate = new Date();
                var startDate = new Date(this.searchform.startPostTime.replace(/-/g, "/"));
                var endDate = new Date(this.searchform.endPostTime.replace(/-/g, "/"));
                if (startDate > endDate) {
                    this.$message({ message: "开始时间不能大于结束时间", type: "warning" });
                    return;
                } else {
                    this.$route.meta.reldata = this.searchform;
                    this.initData();
                }
            } else {
                this.$route.meta.reldata = this.searchform;
                this.initData();
            }

        },
        handleSizeChange(val) {
            this.searchform.pageSize = val;
            this.initData();
        },
        handleCurrentChange(val) {
            this.searchform.pageNum = val;
            this.initData();
        },
        Rowview(val) {
            this.$route.meta.row = val;
            this.$router.push({ path: '/plan/open/view/' + val.postId });
        },
        RowEdit(val) {
            this.$route.meta.row = val;
            this.$router.push({ path: '/plan/open/edit/' + val.postId });
        },
        Rowdelete(val) {

            this.$confirm("确定要删除 '" + val.postTitle + "' 此记录么？", "删除提示", { type: "warning" })
                .then(() => {
                    var Vuethis = this;
                    this.$hrraxios.post(this.$api.plan.postDel, { postId: val.postId })
                        .then((response) => {
                            var redata = response.data;
                            if (redata.success == true) {
                                Vuethis.$message({ message: "删除成功！", type: "success" });
                                Vuethis.initData();
                            } else {
                                Vuethis.$message({ message: redata.prompt, type: "error" });
                            }
                        })
                }).catch((error) => {
                    console.log(error);
                });
        },
        RowSendcmd(val) {
            this.dialogVisible = true;
            this.cmdform.MN = val.Device_Code;
        },
        RowPublic(val) {

        },
        Addclick() {
            this.$router.push({ path: '/plan/open/add/', });
        },
        handleClick(tab, event) {
            console.log(tab, event);
        },
        pubclick() {
            if (this.selectionRows.length == 0) {
                this.$message({ message: "请先选择一行在操作", type: "warning" });
                return;
            }

        },
        editclick() {
            if (this.selectionRows.length == 0) {
                this.$message({ message: "请先选择一行在操作", type: "warning" });
                return;
            }
            if (this.selectionRows.length > 1) {
                this.$message({ message: "只能操作一行数据", type: "warning" });
                return;
            }
            this.$route.meta.row = this.selectionRows[0];
            this.$router.push({ path: '/plan/open/edit/' + this.selectionRows[0].postId });
        },
        delclick() {
            if (this.selectionRows.length < 1) {
                this.$message({ message: "请先选择一行在删除", type: "warning" });
                return;
            }
            this.$confirm("确定要删除这些记录么？", { type: "warning" })
                .then(() => {
                    var loading = this.$loading({
                        lock: true,
                        text: '删除中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    var Vuethis = this;
                    var PostfunArr = [];
                    this.selectionRows.forEach(myrow => {
                        var postRe = this.$hrraxios.post(this.$api.plan.postDel, { postId: myrow.postId });
                        PostfunArr.push(postRe);
                    });
                    this.$axios.all(PostfunArr)
                        .then(this.$axios.spread(function() {
                            loading.close();
                            //console.log(arguments);
                            var isalldel = true;
                            for (var i = 0; i < arguments.length; i++) {
                                if (arguments[i].data.success == false) {
                                    isalldel = false;
                                }
                            }
                            if (isalldel == true) {
                                Vuethis.$message({ message: "全部删除成功！", type: "success" });
                                Vuethis.initData();
                            } else {
                                //有删除失败的未处理
                            }
                        }));
                })
                .catch((error) => {

                });
        },
        cellclick(row, column, cell, event) {
            this.$refs.Opentable.toggleRowSelection(row);
        },
        selectionchange(selection) {
            this.selectionRows = selection;
        },
        initData() {
            var Vuethis = this;
            this.loading = true;
            this.$hrraxios.get(this.$api.realdata.getrealdatalist, { params: this.searchform })
                //this.$hrraxios.get(this.$api.realdata.getrealdatalist+"/"+this.searchform.pageNum+"/"+this.searchform.pageSize)
                .then(function(response) {
                    Vuethis.loading = false;
                    var data = response.data;
                    if (data.Success == true) {
                        let deviceCode=data.Data.List[0].deviceNickCode;

                        if(deviceCode!=undefined&&(deviceCode=='AD0000000312' || deviceCode=='AD0000000307'|| deviceCode=='AD0000000278')){
                                data.Data.List.forEach(element => {
                                    element['light']='70';
                                    element['I1']=4.29680;
                                });
                            }
                        Vuethis.tableData = data.Data.List;
                        Vuethis.total = data.Data.Total;
                    } else {
                        Vuethis.$message.error(data.Data.Prompt);
                    }
                })
                .catch(function(error) {
                    Vuethis.loading = false;
                    console.log(error);
                });
        },
        Refreshchange() {
            var Vuethis = this;
            clearInterval(this.timeId);
            if (this.IsRefresh) {
                this.timeId = setInterval(function() { Vuethis.initData(); }, this.RefreshNum * 1000);
            }
        },
        initParamsData() {
            //this.$common.getplanlist(this,"planIdData");
            //this.$common.getFunListByMCode(this,"PlanOpen");
            var now=new Date();
            var prenow=new Date(now.getTime() - 24 * 60 * 60 * 1000);
            var sTime = prenow.getFullYear() + "-" + (prenow.getMonth() + 1) + "-" + prenow.getDate()+ " " + prenow.getHours() + ":" +prenow.getMinutes()+ ":" + prenow.getSeconds();
            this.searchform.startPostTime = sTime;
            // var now = new Date();
            // now = now.setDate(now.getDate() - 1);
            // now = new Date(now);
            // this.searchform.startPostTime = now;
            
        }
    },
    beforeRouteLeave(to, from, next) {
        // 导航离开该组件的对应路由时调用
        to.meta.row = from.meta.row;
        to.meta.reldata = from.meta.reldata;
        next();
    },
    created() {
        this.$common.getFunListByMCode(this, "DeviceRealData", () => {
            if (this.$route.params.deviceCode) {
                this.searchform.deviceCode = this.$route.params.deviceCode;
                //this.searchform.siteId.push(parseInt(this.$route.params.id));
            }
            if (this.$route.meta.reldata != undefined) {
                var searchformData = this.$route.meta.reldata
                this.searchform.pageNum = searchformData.pageNum;
                this.searchform.pageSize = searchformData.pageSize;
                if (searchformData.advertisementCode != "") {
                    this.selectfield = "advertisementCode";
                    this.keyword = searchformData.advertisementCode;
                    this.searchform.advertisementCode = searchformData.advertisementCode;
                }
                if (searchformData.startPostTime != "") {
                    this.searchform.startPostTime = searchformData.startPostTime;
                }
                if (searchformData.endPostTime != "") {
                    this.searchform.endPostTime = searchformData.endPostTime;
                }
            }
            this.initData();
            this.initParamsData();
        });
        // if(this.IsRefresh){
        // 	this.Refreshchange();
        // }
    }
}
</script>
<style>
.input-with-select {
    width: 110px;
}

.educard label {
    color: #99a9bf;
}

.educard {
    margin-bottom: 10px;
}

.utable .el-button,
.utable .el-button+.el-button {
    margin-right: 10px;
    margin-left: 0;
}
</style>